import { createReducer, on } from '@ngrx/store';
import { TechRegisterState } from './tech-register.state';
import { TechRegisterActions } from '@tech/pages/register/store/tech-register.actions-type';
import { EAppType } from '@shared/models/AppType.enum';

export const initialState: TechRegisterState = <TechRegisterState>{ currentApp: EAppType.Tech };

export const techRegisterStore = createReducer(
  initialState,
  on(TechRegisterActions.initRegistrationGuest, (state, { isLoadingId }) => ({
    ...state,
    isLoading: true,
    isLoadingId,
  })),
  on(TechRegisterActions.initRegistrationGuestDialogClose, (state) => ({
    ...state,
    isLoading: false,
    isLoadingId: '',
  })),
  on(TechRegisterActions.initRegistrationGuestDialogClose, (state) => ({
    ...state,
    isLoading: false,
    isLoadingId: '',
  })),
  on(TechRegisterActions.registerGuestPinRequest, (state, { isLoadingId }) => ({
    ...state,
    isLoading: true,
    isLoadingId: isLoadingId!,
  })),
  on(TechRegisterActions.registerGuestPinRequestSuccess, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(TechRegisterActions.registerGuestPinRequestFail, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(TechRegisterActions.registerGuestAsUser, (state, { isLoadingId }) => ({
    ...state,
    isLoading: true,
    isLoadingId: isLoadingId!,
  })),
  on(TechRegisterActions.registerGuestAsUserSuccess, (state) => ({
    ...state,
    isLoading: true,
    isLogging: true,
  })),
  on(TechRegisterActions.registerGuestAsUserFail, (state) => ({
    ...state,
    isLoading: false,
  }))
);
